export const migratedApiRoutes = {
  'trade-in/devices': {
    url: `devicetradein/api/v1/trade-in/devices`,
    method: 'GET',
  },
  'trade-in/questions': {
    url: `devicetradein/api/v1/trade-in/questions`,
    method: 'GET',
  },
  'trade-in/price': {
    url: `devicetradein/api/v1/trade-in/price`,
    method: 'POST',
  },
};
